import React from "react";
import './TodayEmpty.less';

const TodayEmpty = (props) => (
  <div className="TodayEmptyWrapper">
    <div>It's a new day, we are still waiting for something funny to happen.</div>
    <div>Check back soon...</div>
  </div>
);

export default TodayEmpty;
